import type { CLSFiltersDTO, UserDTO } from '../api/types';
import { CLSType, type CLSFilters, type User } from '../model/types';

export const mapUser = (dto: UserDTO): User => {
  return {
    id: dto.id,
    email: dto.email,
    role: dto.role,
    isActive: dto.isActive,
    ...(dto.lastActiveAt ? { lastActiveAt: dto.lastActiveAt } : {}),
    rlsFilters: [...dto.rlsFilters.dimensionFilters],
    clsFilters: mapCLSFilters(dto.clsFilters),
    viewsRestrictions: dto.viewsRestrictions,
  };
};

const mapCLSFilters = (dto: CLSFiltersDTO): CLSFilters => {
  return {
    type: mapClsFilterType(dto.type),
    columns: dto.columns,
  };
};

const mapClsFilterType = (dtoType: CLSFiltersDTO['type']): CLSType => {
  switch (dtoType) {
    case 'blacklist':
      return CLSType.BLACKLIST;
    case 'whitelist':
      return CLSType.WHITELIST;
    default:
      throw new Error(`Unknown CLS type: ${dtoType}`);
  }
};
